import './App.css';
import RegisterPage from './register/register';

function App() {
    return (
        <div className="App">
            <RegisterPage />
        </div>
    );
}

export default App;
